import Chips from './Chips.vue';

export { Chips };
export default Chips;
